import { Action } from "../actions/glucoseActions"
import { PaginatedModel } from "interfaces/pagination"
import { GlucoseRegister } from "interfaces/glucose"
import { GlucoseActionType } from "state/action-types/glucoseTypes"

const initialState: PaginatedModel<GlucoseRegister> = {
    paginatorInfo: {
        currentPage: 1,
        perPage: 30,
        lastPage: 1,
        total: 0
    },
    data: []
}

const reducer = (state: PaginatedModel<GlucoseRegister> = initialState, action: Action) => {
    switch (action.type) {
        case GlucoseActionType.PAGINATE_GLUCOSE:
            return action.payload
        default:
            return state
    }
}

export default reducer